import {Component, OnInit, Renderer2, OnDestroy, ViewChild, ElementRef} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import * as globals from '../settings';
import {LoginService} from '../shared/navigation/login.service';
import {TimeService} from '../_services/time.service';
import {SubscriptionsService} from '../_services/subscriptions.service';
import {UserService} from '../_services/user.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {CookieService} from 'ngx-cookie-service';
import {LotteriesService} from '../lotteries.service';
import {GetDeviceService} from '../_services/get-device.service';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {BowserService} from 'ngx-bowser';
import {GameLauncherService} from '../_services/game-launcher.service';
import {ActionService} from '../_services/action.service';
import {GetPaymentMethodsService} from '../shared/paymentMethod/get-payment-methods.service';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
    loginForm: FormGroup;
    loginSubscription: Subscription;
    timeZone: any;
    isLoadingButton: any;
    device: any;
    loginValid: any;
    error69: any;
    error70: any;
    error45: any;
    error25: any;
    error10421: any;
    errorDefault: any;
    sessionExpired: any;
    email: any;
    password: any;
    tooltipMessageEmail: any;
    tooltipMessagePassword: any;
    lastType: any;
    emailFinished: any;
    passwordFinished: any;
    emailError: any;
    passwordError: any;
    showGentle: boolean;
    buttonClicked: boolean;
    isLoginBannedSubscription: Subscription;
    isRegisterBannedSubscription: Subscription;
    isLoginBanned: any;
    isRegisterBanned: any;
    @ViewChild('login')
    globalInstance: any;
    close: boolean;
    emailValueFromInput: any;

    constructor(private fb: FormBuilder,
                private loginService: LoginService,
                private timeService: TimeService,
                private subscriptionsService: SubscriptionsService,
                private userService: UserService,
                private renderer: Renderer2,
                private deviceService: DeviceDetectorService,
                private cookieService: CookieService,
                public lotteryService: LotteriesService,
                private getDeviceService: GetDeviceService,
                private translate: TranslateService,
                public bowserService: BowserService,
                public gameLauncher: GameLauncherService,
                public activatedRoute: ActivatedRoute,
                private login: ElementRef,
                public actionService: ActionService,
                private router: Router,
                public getpmService: GetPaymentMethodsService) {
        this.loginForm = fb.group({
            'email': [null, Validators.compose([Validators.required, Validators.pattern('^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))' +
                '@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$')])],
            'password': [null, Validators.compose([Validators.required, Validators.minLength(8)])],
            'validate': ''
        });

        this.showGentle = false;
        this.loginSubscription = this.subscriptionsService.getLogin().subscribe(login => {
            if (login) {
                setTimeout(() => {
                    this.showGentle = true;
                }, 400);
            }
        });
        this.isLoginBannedSubscription = this.subscriptionsService.getIsLoginBanned().subscribe(data => {
            if (data) {
                this.isLoginBanned = data;
            }
        });
        this.isRegisterBannedSubscription = this.subscriptionsService.getIsRegisterBanned().subscribe(data => {
            if (data) {
                this.isRegisterBanned = data;
            }
        });
    }

    ngOnDestroy() {
        if (this.loginSubscription) {
            this.loginSubscription.unsubscribe();
        }
        if (this.isLoginBannedSubscription) {
            this.isLoginBannedSubscription.unsubscribe();
        }
        if (this.isRegisterBannedSubscription) {
            this.isRegisterBannedSubscription.unsubscribe();
        }
    }

    ngOnInit() {
        setTimeout(() => {
            this.translate.get('login.lerror').subscribe(t => {
                this.tooltipMessageEmail = t;
            });
            this.translate.get('login.lperror').subscribe(t => {
                this.tooltipMessagePassword = t;
            });
        }, 500);
        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.translate.get('login.lerror').subscribe(t => {
                this.tooltipMessageEmail = t;
            });
            this.translate.get('login.lperror').subscribe(t => {
                this.tooltipMessagePassword = t;
            });
        });
        this.emailFinished = false;
        this.passwordFinished = false;
        this.emailError = false;
        this.passwordError = false;
        this.isLoadingButton = false;
    }

    logIn(post) {
        this.emailError = false;
        this.passwordError = false;
        this.isLoadingButton = true;
        this.device = this.deviceService.getDeviceInfo();
        this.loginValid = false;
        this.error69 = false;
        this.error70 = false;
        this.error45 = false;
        this.error25 = false;
        this.error10421 = false;
        this.errorDefault = false;
        this.sessionExpired = false;
        this.email = post.description;
        this.password = post.name;
        post.device = (this.device.device !== 'unknown' && this.device.device !== 'Unknown') ? this.device.device : this.getDeviceService.getDevice();
        post.device += ' ';
        post.device += this.device.os_version !== 'unknown' && this.device.os_version !== 'Unknown' ? this.device.os_version : this.getDeviceService.getOSVersion();
        post.os = this.device.os !== 'unknown' && this.device.os !== 'Unknown' ? this.device.os : this.getDeviceService.getOS();
        if (this.bowserService.bowser.name && this.bowserService.bowser.version) {
            post.browser = JSON.stringify(this.bowserService.bowser.name).replace(/"/g, '') + '-' + JSON.stringify(this.bowserService.bowser.version).replace(/"/g, '');

        }
        const urlParam = {};
        let urlParams = '';
        const cookieMcExists: boolean = this.cookieService.check('mc');
        const cookieJlpidExists: boolean = this.cookieService.check('jlpid');
        const cookieCampaignExists: boolean = this.cookieService.check('campaign');
        const cookieReferralExists: boolean = this.cookieService.check('referral');
        const cookieIncentiveCodeExists: boolean = this.cookieService.check('incentiveCode');
        const cookieBtagExists: boolean = this.cookieService.check('btag');
        if (cookieMcExists || cookieJlpidExists || cookieCampaignExists ||
            cookieReferralExists || cookieIncentiveCodeExists || cookieBtagExists) {
            if (cookieMcExists) {
                const mc = this.cookieService.get('mc');
                urlParam['mc'] = mc;
            }
            if (cookieJlpidExists) {
                const jlpid = this.cookieService.get('jlpid');
                urlParam['jlpid'] = jlpid;
            }
            if (cookieCampaignExists) {
                const campaign = this.cookieService.get('campaign');
                urlParam['campaign'] = campaign;
            }
            if (cookieReferralExists) {
                const referral = this.cookieService.get('referral');
                urlParam['referral'] = encodeURIComponent(referral);
            }
            if (cookieIncentiveCodeExists) {
                const incentiveCode = this.cookieService.get('incentiveCode');
                urlParam['cookieValue'] = incentiveCode;
            }
            if (cookieBtagExists) {
                const btag = this.cookieService.get('btag');
                urlParam['bTag'] = btag;
                urlParam['affiliateId '] = btag.split('_')[0];
            }
            urlParams = '?' + this.lotteryService.toSendNoEmail(urlParam);

        }
        this.timeService.getTimezone();
        if (this.loginForm.valid) {
            this.loginService.logIn(globals.appDomain + '/user/login/userLogin_nav_1.json' + urlParams,
                this.loginService.getFormUrlEncoded(post))
                .subscribe(
                    result => {
                        if (result.status === 200 && result.message.ErrorID === undefined && result.message.SessionID !== undefined) {
                            this.subscriptionsService.emitFreshLogin(true);
                            this.renderer.removeClass(document.body, 'modal-open-login');
                            localStorage.removeItem('virtualLogin');
                            localStorage.setItem('knownUser', 'true');
                            const sendData = {};
                            sendData['timeZone'] = this.timeZone;
                            sendData['sessionId'] = result.message.SessionID;
                            this.userService.getUserDetails(result.message.SessionID, result.message.MemberID, true).then(resolver => {
                                if (resolver === 'user') {
                                    this.getpmService.getPaymentMethods();
                                    setTimeout(() => {
                                        this.loginForm.reset();
                                        this.isLoadingButton = false;
                                    }, 1000);
                                    const language = localStorage.getItem('pageLanguage');
                                    setTimeout(() => {
                                        if (this.router.url.includes('/casino') && this.gameLauncher.gameId && this.gameLauncher.minBet) {
                                            this.gameLauncher.runGame(this.gameLauncher.gameId, this.gameLauncher.minBet);
                                        } else {
                                            this.activatedRoute.queryParams.subscribe(params => {
                                                this.actionService.goToAction(params, language, true);
                                            });
                                        }
                                    }, 300);
                                    this.subscriptionsService.triggerNameMagic(true);
                                    setTimeout(() => {
                                        this.subscriptionsService.triggerNameMagic(true);
                                    }, 1000);
                                }
                            });
                        } else if (result && result.message && result.message.OtpCodeSent) {
                          localStorage.setItem('otpRecepientEmail', post.email);
                          this.renderer.addClass(document.body, 'modal-open-login');
                          this.subscriptionsService.emitOtpVerify('login')
                          this.loginForm.reset();
                        } else if (result.message.apiErrorMessage === 'Runtime error.') {
                            this.router.navigate(['/maintenance-break']);
                        } else if (result.message.ErrorID !== undefined) {
                            if (result.message.ErrorID !== undefined) {
                                this.subscriptionsService.emitJinniError(result.message.ErrorID);
                                this.closeError();
                            }
                            this.isLoadingButton = false;
                            if (result.message.ErrorID === '069') {
                                this.error69 = true;
                                setTimeout(() => {
                                    this.error69 = false;
                                }, 15000);
                            } else if (result.message.ErrorID === '070') {
                                this.error70 = true;
                                setTimeout(() => {
                                    this.error70 = false;
                                }, 15000);
                            } else if (result.message.ErrorID === '045') {
                                this.error45 = true;
                                setTimeout(() => {
                                    this.error45 = false;
                                }, 15000);
                            } else if (result.message.ErrorID === '025') {
                                this.error25 = true;
                                setTimeout(() => {
                                    this.error25 = false;
                                }, 15000);
                            } else if (result.message.ErrorId = '10421') {
                                this.error10421 = true;
                                setTimeout(() => {
                                    this.error10421 = true;
                                }, 15000);
                            } else {
                                this.errorDefault = true;
                                setTimeout(() => {
                                    this.errorDefault = false;
                                }, 15000);
                            }
                        } else {
                            this.error69 = false;
                            this.error70 = false;
                            this.error45 = false;
                            this.error25 = false;
                            this.errorDefault = false;
                            this.error10421 = false;
                        }
                    },
                    error => {
                        this.isLoadingButton = false;
                    }
                );
        } else {
            this.buttonClicked = true;
            this.checkPasswordField();
            this.checkEmailField();
            this.isLoadingButton = false;
            this.loginValid = true;
        }
    }

    goToRegistration() {
        if (this.isRegisterBanned) {
            this.subscriptionsService.setIsRestrictedLoginRegister(true);
        } else {
            localStorage.setItem('isOpenRegister', 'true');
            this.renderer.addClass(document.body, 'modal-open-register');
            this.renderer.removeClass(document.body, 'modal-open-login');
            setTimeout(() => {
                localStorage.removeItem('isOpenRegister');
            }, 50);
            this.subscriptionsService.emitRegister(true);
            this.subscriptionsService.emitLogin(false);
        }

    }

    closeLogin() {
        this.isLoadingButton = false;
        this.showGentle = false;
        this.subscriptionsService.emitToggleContent(true);
        this.subscriptionsService.closeModalNow(true);
        this.subscriptionsService.updateTriggeredEndGameSessionIG(false);
        this.renderer.removeClass(document.body, 'modal-open-login');
        setTimeout(() => {
            this.renderer.removeClass(document.body, 'modal-open-register');
            this.subscriptionsService.emitLogin(false);
        }, 1000);
    }

    showTooltip(event, message, invalid) {
        if (invalid === true) {
            this.showTooltipNOW(event, message);
        } else {
            const a = {top: '0', left: '0', show: false, message: message};
            this.subscriptionsService.emitJinniTooltip(a);
        }
    }

    showTooltipNOW(event, message) {
        const viewportOffset = event.srcElement.getBoundingClientRect();
        const top = viewportOffset.top + (viewportOffset.height / 2);
        const left = viewportOffset.left + viewportOffset.width + 9;
        const a = {top: top, left: left, show: true, message: message};
        this.subscriptionsService.emitJinniTooltip(a);
    }

    hideTooltip() {
        const a = {top: '0', left: '0', show: false, message: ''};
        this.subscriptionsService.emitJinniTooltip(a);
    }

    checkAfterKeyDown(field) {
        const timeout = 1000;
        this.lastType = Date.now();

        setTimeout(() => {
            if ((Date.now() - this.lastType) >= timeout) {
                if (field === 'email') {
                    this.emailFinished = true;
                } else if (field === 'password') {
                    this.passwordFinished = true;
                }
            }
        }, timeout);
    }

    checkEmailField() {
        if (this.buttonClicked && this.loginForm.controls.email.invalid) {
            this.emailError = true;
        } else {
            if (this.loginForm.controls.email.dirty && this.loginForm.controls.email.invalid &&
                this.loginForm.controls.email.value.length !== 0 && this.emailFinished) {
                this.emailError = true;
                return true;
            } else {
                this.emailError = false;
            }
        }

    }

    checkPasswordField() {
        if (this.buttonClicked && this.loginForm.controls.password.invalid) {
            this.passwordError = true;
        } else {
            if (this.loginForm.controls.password.dirty && this.loginForm.controls.password.invalid &&
                this.loginForm.controls.password.value.length !== 0 && this.passwordFinished) {
                this.passwordError = true;
                return true;
            } else {
                this.passwordError = false;
            }
        }

    }

    focusOutEmail() {
        if (this.loginForm.controls.email.dirty && this.loginForm.controls.email.invalid &&
            this.loginForm.controls.email.value.length !== 0) {
            this.emailFinished = true;
            this.emailError = true;
            return true;
        }
    }

    focusOutPassword() {
        if (this.loginForm.controls.password.dirty && this.loginForm.controls.password.invalid &&
            this.loginForm.controls.password.value.length !== 0) {
            this.passwordFinished = true;
            this.passwordError = true;
            return true;
        }
    }


    resetPassword() {
        this.subscriptionsService.emitShowForgetPassword('true');
    }

    removeAllSpaces() {
        if (this.emailValueFromInput && this.emailValueFromInput.length >= 2) {
            this.emailValueFromInput = this.emailValueFromInput.replace(new RegExp(' ', 'g'), '');
        }

    }

    closeError() {
        this.globalInstance = this.renderer.listen(this.login.nativeElement, 'click', (event) => {
            if (event.target.id !== 'error-messages') {
                this.globalInstance();
                this.close = true;
                setTimeout(() => {
                    this.close = false;
                }, 1000);
            } else {
                this.globalInstance();
            }
        });
    }
}
